import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=25a324f8&scoped=true"
import script from "./PageForbidden.vue?vue&type=script&lang=ts"
export * from "./PageForbidden.vue?vue&type=script&lang=ts"
import style0 from "./PageForbidden.vue?vue&type=style&index=0&id=25a324f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a324f8",
  null
  
)

export default component.exports